(() => {
  const BRAND_MAP = {
    'pannelli-fotovoltaici': ['AIKO','EGING','Jinko Solar','Peimar','TCL Solar','Trina Solar','Victron Energy'],
    'inverter-fotovoltaici': ['Canadian Solar','Deye','FIMER','FOX ESS','Fronius','Haier','Huawei','Ingeteam','Livoltek','RENON POWER','Sineng','SMA','SolaX Power','Solis','TBEA','WECO','ZCS Azzurro'],
    'batterie-e-accumulo': ['Canadian Solar','Deye','Dyness','FIMER','FOX ESS','Fronius','Haier','Huawei','Ingeteam','Livoltek','Nahui','Peimar','Pylontech','Sineng','SolaX Power','SMA','SolarEdge','Solis','Tesla','Victron Energy','WECO','ZCS Azzurro'],
    'strutture-fotovoltaiche': ['Antai','CGM Impianti','Contact Italia','Megasol','Sunfer','voestalpine'],
    'quadri-e-protezioni': ['CGM Impianti','Iclierre','Lovato','Secsun','Solar Power / SolaX'],
    'cavi-e-accessori': ['CGM Impianti','FOX ESS','Huawei','Ingeteam','Livoltek','Sineng','Tesla','Tigo','Victron Energy'],
    'ricarica-veicoli-elettrici': ['FOX ESS','Fronius','Haier','Huawei','Livoltek','Silla Industries','SMA','SolaX Power','Tesla','Victron Energy','WECO','ZCS Azzurro'],
    'kit-fotovoltaici-completi': ['CGM Impianti']
  };

  const CATEGORY_QUERY_MAP = {
    'pannelli-fotovoltaici': 'product_type:"Modulo FV"',
    'inverter-fotovoltaici': '(product_type:"Inverter ibrido" OR product_type:"Inverter di stringa" OR product_type:"Inverter" OR product_type:"Inverter off-grid/ibrido")',
    'batterie-e-accumulo': '(product_type:"Batteria" OR product_type:"Batteria accumulo" OR product_type:"Batteria per accumulo" OR product_type:"BMS e accessori batteria")',
    'strutture-fotovoltaiche': 'product_type:"Struttura FV"',
    'quadri-e-protezioni': '(product_type:"Quadro elettrico" OR product_type:"Protezione elettrica")',
    'cavi-e-accessori': 'product_type:"Cavo / Accessorio"',
    'ricarica-veicoli-elettrici': 'product_type:"Colonnina e accessorio ricarica EV"',
    'kit-fotovoltaici-completi': 'tag:"kit-completo"'
  };

  const CATEGORY_CGM_LABELS = {
    'strutture-fotovoltaiche': 'Zavorre',
    'quadri-e-protezioni': 'Interfacce, CCI ed equalizzatori',
    'cavi-e-accessori': 'Cavi, connettori e monitoraggio'
  };

  const categoryHandleFromAnchor = (anchor) => {
    try {
      const url = new URL(anchor.href, window.location.origin);
      const match = url.pathname.match(/\/collections\/([^/?#]+)/);
      return match?.[1] || null;
    } catch (_) {
      return null;
    }
  };

  const escapeSearchValue = (value) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

  const brandSearchUrl = (anchor, vendor) => {
    const handle = categoryHandleFromAnchor(anchor);
    const categoryQuery = handle ? CATEGORY_QUERY_MAP[handle] : null;
    if (!handle || !categoryQuery) return anchor.href;

    if (handle === 'kit-fotovoltaici-completi') {
      return '/collections/kit-fotovoltaici-completi?sort_by=manual';
    }
    const vendorQuery = handle === 'batterie-e-accumulo' && vendor === 'ZCS Azzurro'
      ? '(vendor:"ZCS Azzurro" OR vendor:"Zucchetti" OR vendor:"Pylontech / ZCS Azzurro")'
      : `vendor:"${escapeSearchValue(vendor)}"`;
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', `${vendorQuery} AND ${categoryQuery}`);
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('cgm_category', handle);
    url.searchParams.set('cgm_vendor', vendor);
    return `${url.pathname}${url.search}`;
  };

  const makeBrandLink = (anchor, vendor, className) => {
    const link = document.createElement('a');
    link.href = brandSearchUrl(anchor, vendor);
    link.className = className;
    link.textContent = vendor === 'CGM Impianti' ? (CATEGORY_CGM_LABELS[categoryHandleFromAnchor(anchor)] || vendor) : vendor;
    link.dataset.cgmBrand = vendor;
    return link;
  };

  const enhanceDesktop = (root) => {
    root.querySelectorAll('.mega-menu__column > div > a.mega-menu__link[href*="/collections/"]:not(.cgm-brand-link)').forEach((anchor) => {
      const handle = categoryHandleFromAnchor(anchor);
      const brands = BRAND_MAP[handle];
      if (!brands || anchor.dataset.cgmBrandsReady === 'true') return;

      const container = anchor.parentElement;
      if (!container) return;

      anchor.dataset.cgmBrandsReady = 'true';
      anchor.classList.add('mega-menu__link--parent', 'cgm-category-link');

      const list = document.createElement('ul');
      list.className = 'cgm-brand-submenu list-unstyled';
      list.setAttribute('role', 'list');

      brands.forEach((vendor) => {
        const item = document.createElement('li');
        item.appendChild(makeBrandLink(anchor, vendor, 'mega-menu__link cgm-brand-link'));
        list.appendChild(item);
      });

      container.insertBefore(list, anchor.nextSibling);
    });
  };

  const enhanceMobile = (root) => {
    root.querySelectorAll('.header-drawer .menu-drawer__menu--childlist > li > a[href*="/collections/"]').forEach((anchor) => {
      const handle = categoryHandleFromAnchor(anchor);
      const brands = BRAND_MAP[handle];
      if (!brands || anchor.dataset.cgmBrandsReady === 'true') return;

      const item = anchor.parentElement;
      if (!item) return;
      anchor.dataset.cgmBrandsReady = 'true';

      const details = document.createElement('details');
      details.className = 'cgm-brand-details';

      const summary = document.createElement('summary');
      summary.className = `${anchor.className} cgm-brand-summary`;
      summary.innerHTML = `<span class="menu-drawer__menu-item-text wrap-text">${anchor.textContent.trim()}</span><span class="cgm-brand-summary-icon" aria-hidden="true">+</span>`;

      const panel = document.createElement('div');
      panel.className = 'cgm-brand-panel';

      const viewAll = anchor.cloneNode(true);
      viewAll.className = 'menu-drawer__menu-item menu-drawer__menu-item--child cgm-view-all';
      viewAll.textContent = 'Vedi tutti';
      viewAll.removeAttribute('id');
      viewAll.removeAttribute('aria-current');
      panel.appendChild(viewAll);

      const list = document.createElement('ul');
      list.className = 'cgm-mobile-brand-list list-unstyled';
      list.setAttribute('role', 'list');
      brands.forEach((vendor) => {
        const brandItem = document.createElement('li');
        brandItem.appendChild(makeBrandLink(anchor, vendor, 'menu-drawer__menu-item menu-drawer__menu-item--child cgm-mobile-brand-link'));
        list.appendChild(brandItem);
      });
      panel.appendChild(list);

      details.appendChild(summary);
      details.appendChild(panel);
      item.replaceChildren(details);
    });
  };

  const enhanceMenus = () => {
    const header = document.querySelector('#header-group');
    if (!header) return;
    enhanceDesktop(header);
    enhanceMobile(header);
  };

  let scheduled = false;
  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhanceMenus();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceMenus, { once: true });
  } else {
    enhanceMenus();
  }

  const observer = new MutationObserver(scheduleEnhance);
  const startObserver = () => {
    const header = document.querySelector('#header-group');
    if (header) observer.observe(header, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
